export const URL = 'http://13.124.189.169'
export const TERM = 'http://localhost:9090'



// WEBPACK FOOTER //
// ./src/url/BackendUrl.js